import { GoDotFill } from "react-icons/go";
import { IoMdMore } from "react-icons/io";
import { LuUser } from "react-icons/lu";

const ComapnyItem = ({ item }: any) => {
  return (
    <div className="bg-whit shadow-sm border border-gray-200 rounded-[10px] flex  py-4  px-1 justify-between items-center">
      <div className="flex">
        {/* <img width={"100px"}
        className="m-3"
        src={item.logo}
        /> */}

<p className=" cursor-pointer rounded-full w-[50px] h-[50px] border text-[30px] text-center shadow font-bold  border-customGray text-textbg ">{item.orgName.charAt(0)}</p>

        <div className=" px-2">
          <p className="font-semibold text-xs">
            {item.orgName}  
          </p>
          <p className="font-light text-xs"> {item.orgEmail} </p>
          <p className="font-light text-xs">
            <GoDotFill className="inline text-green-600" /> Active
          </p>
        </div>
      </div>

      <IoMdMore size={20} className="text-textbg " />
    </div>
  );
};

export { ComapnyItem };
